
export const u = navigator.userAgent.toLocaleLowerCase();
export const isAndroid = /android|adr|linux/gi.test(u);
export const isiOS = /ipad|iphone|ipod/.test(u);
export const isIpad = /ipad/.test(u);
export const isSafari = /safari/.test(u);
export const isWechat = /micromessenger/i.test(u);
export const isQQ = /qq\//.test(u);
export const isWeibo = /_weibo_/.test(u);
export const isApp = u.indexOf("biliapp") > -1;

